import { PropsWithChildren, useState } from "react"
import { Collapse, IconButton, Stack } from "@mui/material"
import CheckBoxGroupCheckBox from "./check-box-group-check-box"
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { CheckBoxProps } from "@/components/inputs";

export default function CollapseCheckBoxGroup({
    children,
    label,
    ...props
}: CheckBoxProps & PropsWithChildren) {
    const [open, setOpen] = useState(false);

    const handleToggle = () => setOpen(prev => !prev)

    return <Stack>
        <Stack direction={"row"}>
            <ToggleButton open={open} onToggle={handleToggle} />
            <CheckBoxGroupCheckBox
                label={label}
                {...props}
            />
        </Stack>
        <Collapse in={open}>
            <Stack paddingLeft={"40px"}>
                {children}
            </Stack>
        </Collapse>
    </Stack>
}


interface ToggleButtonProps {
    open: boolean,
    onToggle: () => void
}

function ToggleButton({ open, onToggle }: ToggleButtonProps) {
    return <IconButton onClick={onToggle}>
        {open ? <ExpandLess /> : <ExpandMore />}
    </IconButton>
}